import { useState, useEffect } from 'react';
import { Topbar, Sidebar, Loader, Pagination } from "../../../components";
import { authStaff } from "../../../utils/constants";
import { adminPortalRequest } from "../../../Requests/getRequests";
import { useDispatch, useSelector } from "react-redux";
import { selectAccessToken } from "../../../slices/staffSlice";
import { show } from '../../../slices/toastSlice';
import { useNavigate } from 'react-router-dom';
import Item from './Item';
import { HugeiconsIcon } from '@hugeicons/react';
import { FileAddIcon } from '@hugeicons/core-free-icons';

function Index() {

    const accessToken = useSelector(selectAccessToken);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [businessList, setBusinessList] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [metadata, setMetadata] = useState(null);
    const [currentPage, setCurrentPage] = useState(metadata?.currentPage || 1);
    const nPages = metadata?.totalPages;

    const handlePagination = async(page) => {
        setIsLoading(true);
        const res = await adminPortalRequest(`/auth/staff/business/list`, "GET", authStaff(accessToken), { page: page || 1 }, {});
        setIsLoading(false);

        if(res?.code === 401) {
            sessionStorage.clear();
            navigate("/login");
            dispatch(show({ type: "error", state: true, message: "Your session has expired. Please login to continue." }));
            return;
        }
        if(res?.err) { dispatch(show({ type: "error", state: true, message: res?.err })); return; }

        setBusinessList(res.businesses);
        setMetadata(res.metadata);
    };

    useEffect(() => {
        let unsubscribed = false;
        const load = async() => {
            setIsLoading(true);
            const res = await adminPortalRequest(`/auth/staff/business/list`, "GET", authStaff(accessToken), { page: 1 }, {});
            setIsLoading(false);
            if(unsubscribed) return;
            if(res?.code === 401) {
                sessionStorage.clear();
                navigate("/login");
                dispatch(show({ type: "error", state: true, message: "Your session has expired. Please login to continue." }));
                return;
            }
            if(res?.err) { dispatch(show({ type: "error", state: true, message: res?.err })); return; }
            setBusinessList(res.businesses);
            setMetadata(res.metadata);
        };
        load();
        return () => { unsubscribed = true; };
    }, [accessToken, dispatch, navigate]);

    return (
        <div className="main-container">
            <Topbar />
            <Sidebar />

            <main className="main-content">
                <section className="section-container space-y-6">

                    <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-xl bg-rose-50 border border-rose-100 flex items-center justify-center shrink-0">
                            <HugeiconsIcon icon={FileAddIcon} size={18} className="text-rose-500" />
                        </div>
                        <div>
                            <div className="flex items-center gap-2">
                                <h1 className="text-lg font-semibold text-gray-900 dark:text-gray-50">Businesses</h1>
                                {metadata?.totalCount > 0 && (
                                    <span className="px-2 py-0.5 text-xs font-medium bg-gray-100 text-gray-500 rounded-full">
                                        {metadata.totalCount}
                                    </span>
                                )}
                                {isLoading && <Loader color="text-gray-400" size="w-4 h-4" />}
                            </div>
                            <p className="text-sm text-gray-400">Registered businesses on the platform</p>
                        </div>
                    </div>

                    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm overflow-hidden">
                        <table className="min-w-full">
                            <thead>
                                <tr className="bg-gray-50/60 dark:bg-gray-900/60 border-b border-gray-100 dark:border-gray-700">
                                    <th className="px-5 py-3.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide w-[22%]">Name of Business</th>
                                    <th className="px-5 py-3.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide w-[28%]">Owners</th>
                                    <th className="px-5 py-3.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">Phone Numbers</th>
                                    <th className="px-5 py-3.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">Date Established</th>
                                    <th className="px-5 py-3.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">Action</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-50 dark:divide-gray-700/50">
                                {businessList && businessList.length > 0 ? (
                                    businessList.map((item, index) => (
                                        <Item key={index} item={item} />
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" className="px-5 py-10 text-center text-sm text-gray-400">
                                            {isLoading ? 'Loading...' : 'No businesses found'}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        {businessList && (
                            <Pagination
                                nPages={nPages}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                length={metadata.totalCount}
                                handlePagination={handlePagination}
                            />
                        )}
                    </div>

                </section>
            </main>
        </div>
    );
}

export default Index;
